import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterToggle: false,
  productItem: [],
  symbol: "$",
};

const OrganizationSlice = createSlice({
  name: "ProductSlice",
  initialState,
  reducers: {
    setFilterToggle: (state) => {
      state.filterToggle = !state.filterToggle;
    },
    setProductItem: (state, action) => {
      state.productItem = action.payload;
    },
  },
});

export const { setProductItem, setFilterToggle } = OrganizationSlice.actions;
export default OrganizationSlice.reducer;